module.exports = __webpack_public_path__ + "static/media/factories.c6b8f6af.gif";